const SupplementClockInComponent = () => import('@/views/hrm/SupplementClockIn/SupplementClockInView')

export default [
    {
        path:'/SupplementClockInIndex',
        name:'SupplementClockInComponent',
        component:SupplementClockInComponent
    }
]